module.exports = __webpack_public_path__ + "img/card.e61a35e6.png";